import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmarkDelete: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBookmarkDelete"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V22.7232L12 18.1518L20 22.7232V2H4ZM15.5356 7.87869L13.4142 10L15.5356 12.1213L14.1213 13.5355L12 11.4142L9.8787 13.5355L8.46448 12.1213L10.5858 10L8.46448 7.87867L9.8787 6.46445L12 8.58579L14.1213 6.46448L15.5356 7.87869Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookmarkDelete;
